import gsap from "gsap";
import { lenis } from "./smooth-scroll";

export default function scrollIndicator() {
  const target = document.getElementById("scroll-indicator");

  if (!target) return;

  let scrollTrigger = {};

  if (document.querySelector(".is-top")) {
    scrollTrigger = {
      trigger: "body",
      start: "+=1001px",
      endTrigger: "body",
      end: "bottom bottom",
      scrub: true,
    };
  } else {
    scrollTrigger = {
      trigger: "body",
      start: "top top",
      end: "bottom bottom",
      scrub: true,
    };
  }

  gsap.fromTo(
    "#scroll-indicator .scroll-indicator__line-inner",
    {
      yPercent: -100,
    },
    {
      yPercent: 0,
      ease: "none",
      scrollTrigger,
    }
  );

  const link = target.querySelector(".scroll-indicator__page-top");

  link.addEventListener("click", (e) => {
    e.preventDefault();

    lenis.scrollTo("#wrap");
  });
}
